import React from "react";
import { ArrowRight, MessageCircle } from "lucide-react";
import { z } from "zod";

const ButtonSchema = z.object({
	text: z.string(),
	icon: z.any(),
});

const CTABannerSchema = z.object({
	header: z.string().default("Ready to bring your next building to digital life?"),
	description: z
		.string()
		.default(
			"Join thousands of architects who've transformed their projects with our BIM expertise network."
		),
	primaryButton: ButtonSchema.default({
		text: "Post Your BIM Project",
		icon: ArrowRight,
	}),
	secondaryButton: ButtonSchema.default({
		text: "Chat with Support",
		icon: MessageCircle,
	}),
	features: z.string().default("⚡ Free to post • 💬 Instant support • 🔒 Secure payments"),
});

type CTABannerProps = z.input<typeof CTABannerSchema>;

const CTABanner: React.FC<CTABannerProps> = (props = {}) => {
	const data = CTABannerSchema.parse(props);
	return (
		<section className="bg-gradient-to-r from-primary-600 via-primary-500 to-secondary-500 py-20">
			<div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
				<h2 className="mb-4 text-3xl font-bold text-white md:text-4xl">{data.header}</h2>
				<p className="mx-auto mb-8 max-w-3xl text-xl text-blue-100">{data.description}</p>

				<div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
					<button className="flex transform items-center space-x-2 rounded-lg bg-accent-500 px-8 py-4 text-lg font-semibold text-white shadow-lg transition-all hover:scale-105 hover:bg-accent-600">
						<span>{data.primaryButton.text}</span>
						<data.primaryButton.icon className="h-5 w-5" />
					</button>

					<button className="flex items-center space-x-2 rounded-lg border-2 border-white px-8 py-4 text-lg font-semibold text-white transition-all hover:bg-white hover:text-primary-500">
						<data.secondaryButton.icon className="h-5 w-5" />
						<span>{data.secondaryButton.text}</span>
					</button>
				</div>

				<div className="mt-8 text-blue-100">
					<p className="text-sm">{data.features}</p>
				</div>
			</div>
		</section>
	);
};

export default CTABanner;
